import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 36,
		height: 45,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function AddCompleteSetIcon(props) {
	return (
		<svg width="36" height="45" viewBox="0 0 36 45" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M2 45H34C35.1046 45 36 44.1046 36 43V11.8709C36 10.8687 35.6237 9.90292 34.9457 9.16484L27.715 1.29391C26.9575 0.469326 25.889 0 24.7693 0H2C0.89543 0 0 0.89543 0 2V43C0 44.1046 0.895431 45 2 45Z" fill={props.fill} />
			<path opacity="0.5" d="M24 0V11C24 12.1046 24.8954 13 26 13H36" stroke="white" strokeWidth="2" />
			<path opacity="0.5" d="M18 23V32M18 32L15 30M18 32L21 30" stroke="white" strokeWidth="2" strokeLinecap="round" />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<AddCompleteSetIcon fill={props.fill} />
		</div>
	);
}